import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getBearerToken } from '../auth-token';
import { getAppName } from '../runtime-config';

const APPLICATION_HEADER = '75F-Application';
const AUTHORIZATION_HEADER = 'Authorization';

export const jwtInterceptor: HttpInterceptorFn = (request, next) => {
  const token = getBearerToken();
  const headers: Record<string, string> = {
    [APPLICATION_HEADER]: getAppName()
  };

  if (token && !request.url.includes('sso/verifytoken')) {
    headers[AUTHORIZATION_HEADER] = `Bearer ${token}`;
  }

  const authRequest = request.clone({ setHeaders: headers });

  return next(authRequest).pipe(
    catchError((error: HttpErrorResponse) => throwError(() => error))
  );
};
